import { uiSize } from '@utils'

interface Props {
  color?: string
}

function PayoutIcon({ color = 'currentColor' }: Props) {
  return (
    <svg
      width={uiSize(14)}
      height={uiSize(14)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke={color}
      strokeWidth='2.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M21 3 10 14M21 3l-7 18-4-7-7-4z' />
    </svg>
  )
}

export default PayoutIcon
